
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/money-fortune/DoKwon",
      function () {
        return require("private-next-pages/money-fortune/DoKwon.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/money-fortune/DoKwon"])
      });
    }
  